import React from "react";
import { useI18n } from "../i18n/I18nProvider";
import { Sparkles, ShieldCheck, Gift } from "lucide-react";

export default function Hygiene() {
  const { t } = useI18n();
  const h = t.hygiene;

  const items = [
    { icon: Sparkles, title: h.item1_title, desc: h.item1_desc },
    { icon: Gift, title: h.item2_title, desc: h.item2_desc },
    { icon: ShieldCheck, title: h.item3_title, desc: h.item3_desc },
  ];

  return (
    <section
      id="hygiene"
      className="relative py-24 sm:py-32 bg-[#0a0a0a] border-y border-white/5"
      data-testid="hygiene-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* Left: heading */}
          <div className="lg:col-span-5">
            <div className="text-[11px] tracking-[0.35em] uppercase font-bold text-scooter-yellow mb-3" data-testid="hygiene-label">
              {h.label}
            </div>
            <h2 className="font-heading font-black text-white text-4xl sm:text-5xl tracking-tighter leading-[0.95] mb-6" data-testid="hygiene-title">
              {h.title}
            </h2>
            <p className="text-zinc-400 text-base leading-relaxed max-w-md" data-testid="hygiene-intro">
              {h.intro}
            </p>
            <div className="mt-8 inline-flex items-center gap-3 border border-scooter-yellow/40 bg-scooter-yellow/5 px-4 py-3">
              <span className="text-2xl">🎁</span>
              <span className="text-xs tracking-[0.2em] uppercase font-bold text-scooter-yellow" data-testid="hygiene-free-badge">
                {h.free_badge}
              </span>
            </div>
          </div>

          {/* Right: 3 pillars */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {items.map((it, i) => {
              const Icon = it.icon;
              return (
                <div
                  key={it.title}
                  className="border border-white/10 bg-black/40 p-6 flex flex-col gap-4 hover:border-scooter-yellow/40 transition-colors"
                  data-testid={`hygiene-item-${i}`}
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-scooter-yellow text-black flex-shrink-0">
                    <Icon className="w-6 h-6" strokeWidth={2.2} />
                  </div>
                  <div>
                    <div className="font-heading font-black text-white text-lg tracking-tight mb-2 leading-tight">
                      {it.title}
                    </div>
                    <p className="text-zinc-400 text-sm leading-relaxed">{it.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
